import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'

const vue = new Vue()

const state = {
  // 父级
  page: [],
  dataDictionaryMark: 0,
  parentPage: []
  // pageTotal: 0,
  // 子级
  // pageChild: [
  //   {
  //     code: 'LXY_SEX_MALE',
  //     name: '男',
  //     val: '',
  //     parentCode: 'LXY_SEX',
  //     sort: '',
  //     remark: ''
  //   },
  //   {
  //     code: 'LXY_SEX_FEMALE',
  //     name: '女',
  //     val: '',
  //     parentCode: 'LXY_SEX',
  //     sort: '',
  //     remark: ''
  //   }
  // ],
  // pageChildTotal: 0
}

const actions = {
  /*
  * 父级
  * */
  // 列表
  [types.GETPAGE] (context, params) {
    http.fetch('/api/dict/getTree', params).then(data => {
      context.commit(types.GETPAGE, data)
    })
  },
  // 父级列表
  [types.GETPAGEPARENT] (context, params) {
    http.fetch('/api/dict/getParent', params).then(data => {
      context.commit(types.GETPAGEPARENT, data)
    })
  },
  // 新增
  [types.ADDPAGE] (context, params) {
    http.fetch('/api/dict/add', params).then(data => {
      context.commit(types.ADDPAGE, data)
    })
  },
  // 编辑
  [types.EDITPAGE] (context, params) {
    http.fetch('/api/dict/update', params).then(data => {
      context.commit(types.EDITPAGE, data)
    })
  },
  // 删除
  [types.DELETEPAGE] (context, params) {
    http.fetch('/api/dict/del', params).then(data => {
      context.commit(types.DELETEPAGE, {...data, ...params})
    })
  }
}

const mutations = {
  /*
  * 父级
  * */
  // 列表
  [types.GETPAGE] (state, data) {
    state.page = data.obj
    // state.pageTotal = data.total
  },
  // 父级列表
  [types.GETPAGEPARENT] (state, data) {
    state.parentPage = data.obj
  },
  // 新增
  [types.ADDPAGE] (state, data) {
    if (data.success) {
      state.dataDictionaryMark = 1
      vue.$message({
        showClose: true,
        message: '新增成功',
        type: 'success'
      })
    }
  },
  // 编辑
  [types.EDITPAGE] (state, data) {
    if (data.success) {
      state.dataDictionaryMark = 1
      vue.$message({
        showClose: true,
        message: '编辑成功',
        type: 'success'
      })
    }
  },
  // 删除
  [types.DELETEPAGE] (state, data) {
    if (data.success) {
      state.dataDictionaryMark = 1
      let text = '删除成功'
      if (data.status === 1) {
        text = '启用成功'
      } else if (data.status === 2) {
        text = '禁用成功'
      }
      vue.$message({
        showClose: true,
        message: text,
        type: 'success'
      })
    }
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/dataDictionary/index.js